import { defineMessages } from "react-intl";

export const messages = defineMessages({
  decreaseQuantity: {
    id: "njEppQ",
    defaultMessage: "Decrease quantity",
    description: "button on mobile order line, lowers quantity by one",
  },
  increaseQuantity: {
    id: "2+3nWA",
    defaultMessage: "Increase quantity",
    description: "button on mobile order line, raises quantity by one",
  },
});
